import TargetsContainer from './containers/TargetsContainer';

export default TargetsContainer;